<div style="margin-top: 20px; margin-left: 10px;">
<h1>You will be redirected with in seconds...!</h1>
<span>Please do not close or refresh this page.</span>
</div>
